/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import { useTranslation } from 'react-i18next';

import RadioColumn from './RadioColumn';

import GoogleIcon from '@mui/icons-material/Google';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import ReadIcon from '@mui/icons-material/ReadMore';
import ColleagueIcon from '@mui/icons-material/People';
import MoreIcon from '@mui/icons-material/MoreHoriz';
import CompanyIcon from '@mui/icons-material/BusinessCenter';
import PersonIcon from '@mui/icons-material/Person';
import SchoolIcon from '@mui/icons-material/School';
import ScienceIcon from '@mui/icons-material/Science';

export default function Step2({
  howFound,
  howFoundOtherText,
  userType,
  userTypeOtherText,
  onUpdate,
}) {
  const { t } = useTranslation();

  const howOptions = [
    { title: t('Google'), value: 'google', icon: GoogleIcon },
    { title: t('LinkedIn'), value: 'linkedin', icon: LinkedInIcon },
    { title: t('Läste om er'), value: 'read', icon: ReadIcon },
    { title: t('Kollega'), value: 'colleague', icon: ColleagueIcon },
    { title: t('Annat'), value: 'other', icon: MoreIcon },
  ];

  const userOptions = [
    { title: t('Företag'), value: 'company', icon: CompanyIcon },
    { title: t('Privatperson'), value: 'private', icon: PersonIcon },
    { title: t('Student'), value: 'student', icon: SchoolIcon },
    { title: t('Forskare'), value: 'researcher', icon: ScienceIcon },
    { title: t('Annat'), value: 'other', icon: MoreIcon },
  ];

  return (
    <div
      css={css`
        display: flex;
        gap: 1rem;

        @media (max-width: 700px) {
          flex-direction: column;
        }
      `}
    >
      <RadioColumn
        title={t('Hur hörde du talas om Klang.ai?')}
        value={howFound}
        text={howFoundOtherText}
        label={t('Ange hur du hittade oss')}
        onValueChange={(value) => onUpdate({ howFound: value })}
        onTextChange={(text) => onUpdate({ howFoundOtherText: text })}
        options={howOptions}
      />
      <RadioColumn
        title={t('Vilken typ av användare är du?')}
        value={userType}
        text={userTypeOtherText}
        label={t('Ange din användartyp')}
        onValueChange={(value) => onUpdate({ userType: value })}
        onTextChange={(text) => onUpdate({ userTypeOtherText: text })}
        options={userOptions}
      />
    </div>
  );
}
